import React from "react";
import { t } from "ttag";

import { HorizontalScrollCardsBlock } from "@reactivated";

import { ImageChooserBlock } from "@thelabnyc/thelabui/src/components/ImageChooserBlock";

import { Carousel } from "../Carousel";
import { ButtonTextPrimary, IconButton } from "../Clickables";
import { H, HLevel } from "../Headings";
import { RichText } from "../RichText";
import { Svg } from "../Svg";
import { ThemedModule } from "../ThemedModule";

import styles from "./HorizontalScrollCards.module.scss";

type Card = NonNullable<HorizontalScrollCardsBlock["cards"]>[number];

const Slide = ({ card }: { card: Card }) => (
    <article className={styles.card}>
        <HLevel>
            {card.value.image && <ImageChooserBlock value={card.value.image} />}
            <H className={styles.headline}>{card.value.headline}</H>
            {card.value.body && <RichText value={card.value.body} />}
            {card.value.cta?.display_name && card.value.cta.url && (
                <ButtonTextPrimary simpleLink={card.value.cta}>
                    {card.value.cta.display_name}
                    <Svg name="arrow" />
                </ButtonTextPrimary>
            )}
        </HLevel>
    </article>
);

export const HorizontalScrollCards = (props: {
    value: HorizontalScrollCardsBlock;
}) => (
    <ThemedModule theme={props.value.module_theme}>
        <Carousel
            containerProps={{
                className: props.value.number_cards
                    ? styles.numbered
                    : styles.carousel,
            }}
            label={t`Card list`}
            controls={({ allVisible }) => (
                <div
                    className={
                        allVisible ? styles.hiddenControls : styles.controls
                    }
                >
                    <IconButton icon="caret" slot="previous" />
                    <IconButton icon="caret" slot="next" />
                </div>
            )}
            scrollContainerProps={{ className: styles.scroller }}
            dots={false}
        >
            {props.value.cards?.map((card) => (
                <Slide key={card.id} card={card} />
            ))}
        </Carousel>
    </ThemedModule>
);
